/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step3Inputs */

const en_landing_workflow_step3 = /** @type {(inputs: Landing_Workflow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Injection`)
};

const de_landing_workflow_step3 = /** @type {(inputs: Landing_Workflow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword-Einbau`)
};

const fr_landing_workflow_step3 = /** @type {(inputs: Landing_Workflow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Injection`)
};

const es_landing_workflow_step3 = /** @type {(inputs: Landing_Workflow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Injection`)
};

const it_landing_workflow_step3 = /** @type {(inputs: Landing_Workflow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Injection`)
};

const nl_landing_workflow_step3 = /** @type {(inputs: Landing_Workflow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Injection`)
};

const pl_landing_workflow_step3 = /** @type {(inputs: Landing_Workflow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Injection`)
};

const fi_landing_workflow_step3 = /** @type {(inputs: Landing_Workflow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Injection`)
};

const da_landing_workflow_step3 = /** @type {(inputs: Landing_Workflow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Injection`)
};

const sv_landing_workflow_step3 = /** @type {(inputs: Landing_Workflow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Injection`)
};

/**
* | output |
* | --- |
* | "Keyword Injection" |
*
* @param {Landing_Workflow_Step3Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_workflow_step3 = /** @type {((inputs?: Landing_Workflow_Step3Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step3Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_workflow_step3(inputs)
	if (locale === "fr") return fr_landing_workflow_step3(inputs)
	if (locale === "es") return es_landing_workflow_step3(inputs)
	if (locale === "it") return it_landing_workflow_step3(inputs)
	if (locale === "nl") return nl_landing_workflow_step3(inputs)
	if (locale === "pl") return pl_landing_workflow_step3(inputs)
	if (locale === "fi") return fi_landing_workflow_step3(inputs)
	if (locale === "da") return da_landing_workflow_step3(inputs)
	if (locale === "sv") return sv_landing_workflow_step3(inputs)
	return en_landing_workflow_step3(inputs)
});